import { render, staticRenderFns } from "./RecommendationContainer.vue?vue&type=template&id=ee41e3b2&"
import script from "./RecommendationContainer.vue?vue&type=script&lang=js&"
export * from "./RecommendationContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports